import telwoord from '../../helpers/intelligence/telwoord'

/**
 * De stand van de signaalcel van één concreet mechanisme, als zin. Eén
 * organisatie is geen uitspraak, en dat staat erbij.
 * @param {object|null} cel
 */
const signaalTekst = (cel) => {
    if (!cel) return 'Nog geen eigen cel voor dit mechanisme bij deze doelgroep.'
    const cijfers = `${telwoord(cel.nOrgs, 'organisatie', 'organisaties')}, ${telwoord(cel.nRespondents, 'respondent', 'respondenten')}`
    const d = typeof cel.d === 'number' ? `, ${cel.d.toFixed(2)} d` : ''
    return cel.nOrgs < 2 ? `${cijfers}${d} — één organisatie, geen uitspraak.` : `${cijfers}${d} · ${cel.classificationLabel || cel.classification}`
}

/**
 * De concrete mechanismen die de bijdragende organisaties in deze categorie
 * inzetten — de verdeling onder de categorie — elk met de stand van zijn eigen
 * (signaal)cel als die bestaat.
 *
 * @param {object} props
 * @param {Array<{mechanismId: string, orgId: string, orgName: string, title: string, description: string, signalCell: (object|null)}>} props.mechanisms
 */
const CellMechanismsSection = ({ mechanisms }) => {
    if (mechanisms.length === 0) {
        return <p className="intelligence-state">Geen van de bijdragende organisaties heeft een mechanisme in deze categorie.</p>
    }
    return (
        <div className="intelligence-agenda-list">
            {mechanisms.map((m) => (
                <div key={m.mechanismId || `${m.orgId}:${m.title}`} className="intelligence-agenda-row">
                    <div className="intelligence-agenda-row__body">
                        <p className="intelligence-agenda-row__title">
                            {m.title} <span className="intelligence-badge intelligence-badge--dimensie">{m.orgName || '(organisatie zonder naam)'}</span>
                        </p>
                        {m.description && <span className="intelligence-agenda-row__stand">{m.description}</span>}
                        <span className="intelligence-agenda-row__gap">{signaalTekst(m.signalCell)}</span>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default CellMechanismsSection
